/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_CaptchaInputs */

const en_try_magic_error_captcha = /** @type {(inputs: Try_Magic_Error_CaptchaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not verify you are human. Please refresh and try again.`)
};

const es_try_magic_error_captcha = /** @type {(inputs: Try_Magic_Error_CaptchaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos verificar que eres humano. Por favor recarga e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We could not verify you are human. Please refresh and try again." |
*
* @param {Try_Magic_Error_CaptchaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_captcha = /** @type {((inputs?: Try_Magic_Error_CaptchaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_CaptchaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_captcha(inputs)
	return en_try_magic_error_captcha(inputs)
});